import * as _ from 'lodash/fp';


export enum DetailTabsList {
    tasksTab = 'Tasks',
    taskSummaryTab = 'Task Summary',
}

export const CDetailTabs = _.values(DetailTabsList);
